import { useCallback, useLayoutEffect, useRef, useState } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import { useOnElementWidthChange } from '../../../../../hooks/use-on-element-width-change';
import { EnhancedReturnDetailsGridLayout } from '../enhanced-return-details-grid-layout';

import style from './resize-observer-layout.module.less';

const TWO_COLUMN_BREAKPOINT = 700;
const ONE_COLUMN_BREAKPOINT = 400;

const columnCountToClassNameMap = {
  1: style['one-column'],
  2: style['two-columns'],
  3: style['three-columns'],
};

export const LayoutContainer = ({ addressColumnContent, costSummaryColumnContent, rmaColumnContent }) => {
  const [columnCount, setColumnCount] = useState(3);
  const [isContainerLoaded, setIsContainerLoaded] = useState(false);

  const containerRef = useRef(null);

  const updateLayout = useCallback((width) => {
    if (width <= ONE_COLUMN_BREAKPOINT) {
      setColumnCount(1);
    } else if (width <= TWO_COLUMN_BREAKPOINT) {
      setColumnCount(2);
    } else {
      setColumnCount(3);
    }
  }, []);

  useLayoutEffect(() => {
    if (containerRef.current) {
      updateLayout(containerRef.current?.offsetWidth);
      setIsContainerLoaded(true);
    }
  }, [updateLayout]);

  useOnElementWidthChange(containerRef, updateLayout);

  return (
    <div ref={containerRef} className={style['enhanced-return-details-grid-container']} data-type='resize-observer-fallback'>
      {isContainerLoaded ? (
        <EnhancedReturnDetailsGridLayout
          addressColumnContent={addressColumnContent}
          className={classnames(style['enhanced-return-details-grid'], columnCountToClassNameMap[columnCount])}
          costSummaryColumnContent={costSummaryColumnContent}
          rmaColumnContent={rmaColumnContent}
        />
      ) : (
        <LoadingIndicator />
      )}
    </div>
  );
};

LayoutContainer.propTypes = {
  addressColumnContent: PropTypes.node.isRequired,
  rmaColumnContent: PropTypes.node.isRequired,
  costSummaryColumnContent: PropTypes.node.isRequired,
};
